/**
 * Created by roi on 2/05/17.
 */
import { OBSERVACIO_OBTENIR_ESTATS, OBSERVACIO_INICIALITZAR } from '../../actions/actionTypes';

/*Obtenir els estats de les observacions de 30 dies
 (des de la data actual fins 30 dies anteriors)*/
const ESTAT_INICIAL_ESTATS_OBSERVACIONS = [];

const estats = (state = ESTAT_INICIAL_ESTATS_OBSERVACIONS, action) => {
    switch (action.type) {
        case OBSERVACIO_OBTENIR_ESTATS:
            return action.estatsObservacions;
        case OBSERVACIO_INICIALITZAR:
            return ESTAT_INICIAL_ESTATS_OBSERVACIONS;
        default:
            return state;
    }
};

export default estats;



// WEBPACK FOOTER //
// ./src/reducers/observacio/estats.js